import { Role } from 'api/merchantUsers'
import { I18n } from 'react-redux-i18n'

function roleTitle(role: Role, isMall = false): string {
  const key = `${role}${role === 'manager' && isMall ? '_mall' : ''}`

  return I18n.t(`merchant_users.roles.${key}`)
}

function emailDomain(email: string): string {
  const parts = email.trim().toLowerCase().split('@')
  return parts.length > 1 ? parts[parts.length - 1] : ''
}

// True when any address in `email` (the field accepts a comma-separated list)
// uses a domain none of the merchant's existing users have. Returns false when
// there is no existing baseline, so the merchant's first user never warns.
function isNewEmailDomain(email: string, existingEmails: string[]): boolean {
  const existingDomains = new Set(
    existingEmails.map(emailDomain).filter(Boolean)
  )
  if (existingDomains.size === 0) return false

  return email
    .split(',')
    .map(emailDomain)
    .filter(Boolean)
    .some(domain => !existingDomains.has(domain))
}

export { isNewEmailDomain, roleTitle }
